if (typeof p80 === typeof undefined) {
	var p80 = {};
}

p80.mainNavigation = function (config) {
	this.config = {};
	this.config.mouseOutDelay = config && config.mouseOutDelay ? config.mouseOutDelay : 800;
	this.config.secondaryMouseOutDelay =
		config && config.secondaryMouseOutDelay ? config.secondaryMouseOutDelay : 300;
	this.config.mobileBreakPoint =
		config && config.mobileBreakPoint ? config.mobileBreakPoint : 1200;

	this.html = document.getElementById('main-menu');

	// Our menu links/buttons
	this.primaryLinks = this.html.getElementsByClassName('main-menu__sub-menu-wrapper');
	this.secondaryLinks = this.html.getElementsByClassName('main-menu__sub-menu-item');
	this.tertiaryLinks = this.html.getElementsByClassName('main-menu__teriary-menu-item');
	this.btnCloseMenu = this.html.getElementsByClassName('close-menu-button');

	// Third level menu wrappers
	this.tertiaryMenuWrappers = this.html.getElementsByClassName(
		'main-menu__tertiary-menu-wrapper'
	);

	// Our menu flyout toggles
	this.mobileNavToggles = document.getElementsByClassName('header__nav-toggle');

	// The default displayed menu by default is determined by the current page URL being a child (or element) within our menu bar
	// Updated logic always takes the *last* entry for active links if we have duplicate active links
	this.defaultActiveMenu = null;
	const activeChildren = this.html.querySelectorAll('.main-menu__sub-menu-item--active-children');
	const lastActiveChild = activeChildren[activeChildren.length - 1];
	if (lastActiveChild) {
		this.defaultActiveMenu = lastActiveChild.closest('.main-menu__sub-menu-wrapper');
	}

	// If the current page URL is not present in the nav, we render the first nav list by default
	if (!this.defaultActiveMenu) {
		this.defaultActiveMenu = this.primaryLinks[0];
	}

	// add the active class
	if (this.defaultActiveMenu) {
		this.defaultActiveMenu.classList.add('main-menu__sub-menu-wrapper--active');
	}

	// Holds our currently displayed menu
	this.currentActiveMenu = this.defaultActiveMenu;
	// Holds our currently highlighted secondary nav item
	this.currentActiveSecondaryUnderline = null;
	// Holds our currently displayed secondary menu
	this.currentActiveSecondaryMenu = null;
	// Holds our menu close timeout so we can set/clear on demand based on user mouse movements
	this.mainMenuTimer = null;
	// Holds our secondary menu close timeout so we can set/clear on demand based on user mouse movements
	this.secondaryMenuTimer = null;
	// Holds our secondary menu open timer so we can delay how long it takes to open the secondary menu
	this.secondaryMenuOpenTimer = null;

	this.focusTimer = null;
	this.isFocused = false;

	// Holds the state of our mobile menu
	this.mobileNavOpen = false;

	// Adds a class to our tertiary menu wrappers to update styles to min-height and height: 100% instead of using static height: 533px
	// This helps with CLS, and ensures that any menus that need to grow out of our static height can do so after the page is loaded
	for (var x = 0; x < this.tertiaryMenuWrappers.length; x++) {
		this.tertiaryMenuWrappers[x].classList.add('main-menu__tertiary-menu-wrapper--loaded');
	}

	this.bind();
};
p80.mainNavigation.prototype.bind = function () {
	const navigation = this;

	if (document.readyState !== 'loading') {
		setTimeout(function () {
			navigation.resetPrimaryUnderline();
			navigation.resetSecondaryUnderline();
		}, 1000);
	} else {
		setTimeout(function () {
			navigation.resetPrimaryUnderline();
			navigation.resetSecondaryUnderline();
		}, 1000);
	}

	window.addEventListener('click', function (e) {
		if (!navigation.html.contains(e.target)) {
			navigation.closeOpenPrimaryMenu();
			navigation.setDefaultActiveMenu();
			navigation.resetPrimaryUnderline();
			navigation.closeOpenSecondaryMenu();
			navigation.resetSecondaryUnderline();
			clearTimeout(navigation.secondaryMenuTimer);
			clearTimeout(navigation.mainMenuTimer);
		}
	});

	window.addEventListener('keydown', function (e) {
		if (e.key === 'Escape') {
			navigation.closeOpenPrimaryMenu();
			navigation.setDefaultActiveMenu();
			navigation.resetPrimaryUnderline();
			navigation.closeOpenSecondaryMenu();
			navigation.resetSecondaryUnderline();
			clearTimeout(navigation.secondaryMenuTimer);
			clearTimeout(navigation.mainMenuTimer);
		}
	});

	// Delay our initial menu activation when the mouse first enters the header from elsewhere
	document.querySelector('header').addEventListener('mouseenter', function (e) {
		if (!navigation.focusTimer) {
			navigation.focusTimer = setTimeout(function () {
				navigation.isFocused = true;
			}, 400);
		}
	});
	document.querySelector('header').addEventListener('mouseleave', function (e) {
		navigation.isFocused = false;
		clearTimeout(navigation.focusTimer);
	});

	// When the mouse/keyboard enters our primary nav we add an active class and set our current active menu as well as close any open menus
	for (var x = 0; x < navigation.primaryLinks.length; x++) {
		navigation.primaryLinks[x].addEventListener(
			'mouseover',
			function (e) {
				if (window.innerWidth < navigation.config.mobileBreakPoint) return;
				navigation.closeOpenPrimaryMenu();
				if (!e.target.classList.contains('main-menu__submenu')) {
					//navigation.closeOpenSecondaryMenu();
					navigation.updatePrimaryUnderline(this);
				}
				this.classList.add('main-menu__sub-menu-wrapper--active');
				// Avoid calling reset on extra child item hovers to avoid animation stuttering
				if (
					(navigation.currentActiveSecondaryUnderline &&
						!e.target.classList.contains('main-menu__submenu') &&
						!e.target === navigation.currentActiveSecondaryUnderline) ||
					(navigation.currentActiveSecondaryUnderline &&
						!e.target.classList.contains('main-menu__submenu') &&
						!navigation.currentActiveSecondaryUnderline.contains(e.target)) ||
					!navigation.currentActiveSecondaryUnderline
				) {
					navigation.resetSecondaryUnderline();
				}
				navigation.currentActiveMenu = this;
			},
			true
		);
		navigation.primaryLinks[x].addEventListener(
			'focus',
			function (e) {
				if (window.innerWidth < navigation.config.mobileBreakPoint) return;
				navigation.closeOpenPrimaryMenu();
				if (!e.target.classList.contains('main-menu__submenu'))
					navigation.closeOpenSecondaryMenu();
				this.classList.add('main-menu__sub-menu-wrapper--active');
				navigation.updatePrimaryUnderline(this);
				navigation.resetSecondaryUnderline();
				navigation.currentActiveMenu = this;
			},
			true
		);
		navigation.primaryLinks[x].querySelector('.main-menu__item').addEventListener(
			'click',
			function (e) {
				if (window.innerWidth >= navigation.config.mobileBreakPoint) return;
				e.preventDefault();
				// Don't close the menu on a child item click
				let childList;
				if (navigation.currentActiveMenu) {
					childList =
						navigation.currentActiveMenu.getElementsByClassName('main-menu__submenu');
					if (childList.length > 0) childList = childList[0];
				}
				if (childList && childList.contains(e.target)) return;
				// On clicking the current active menu, close open menus but do not re-open the current menu
				if (
					navigation.currentActiveMenu.contains(e.target) &&
					navigation.currentActiveMenu.classList.contains(
						'main-menu__sub-menu-wrapper--active'
					)
				) {
					navigation.closeOpenPrimaryMenu();
					navigation.closeOpenSecondaryMenu();
					return;
				}
				navigation.closeOpenPrimaryMenu();
				navigation.closeOpenSecondaryMenu();
				navigation.currentActiveMenu = this.closest('li');
				navigation.currentActiveMenu.classList.add('main-menu__sub-menu-wrapper--active');
			},
			true
		);
		navigation.primaryLinks[x].addEventListener(
			'mouseout',
			function (e) {
				if (window.innerWidth < navigation.config.mobileBreakPoint) return;
				// Set a timer which will automatically close our menu (if the mouse pointer has not entered the appropriate sub-menu in time)
				navigation.mainMenuTimer = setTimeout(function () {
					navigation.closeOpenPrimaryMenu();
					navigation.closeOpenSecondaryMenu();
					navigation.setDefaultActiveMenu();
					navigation.resetPrimaryUnderline();
				}, navigation.config.mouseOutDelay);
			},
			true
		);

		// When the mouse/keyboard enters a sub-nav, we clear the timer that would have automatically closed the sub nav
		navigation.primaryLinks[x].addEventListener(
			'mouseover',
			function (e) {
				if (window.innerWidth < navigation.config.mobileBreakPoint) return;
				clearTimeout(navigation.mainMenuTimer);
			},
			true
		);
		navigation.primaryLinks[x].addEventListener(
			'focus',
			function (e) {
				if (window.innerWidth < navigation.config.mobileBreakPoint) return;
				clearTimeout(navigation.mainMenuTimer);
			},
			true
		);
	}

	// When the mouse/keyboard enters the secondary nav we add an active class and set our current active sub menu as well as clear any set menu timeout
	for (var x = 0; x < navigation.secondaryLinks.length; x++) {
		navigation.secondaryLinks[x].addEventListener(
			'mouseover',
			function (e) {
				const menu = this;
				navigation.updateSecondaryUnderline(menu);
				clearTimeout(navigation.secondaryMenuTimer);
				clearTimeout(navigation.secondaryMenuOpenTimer);
				navigation.isFocused = true;
			},
			true
		);
		navigation.secondaryLinks[x].addEventListener(
			'focusin',
			function (e) {
				if (window.innerWidth < navigation.config.mobileBreakPoint) return;
				this.preventClick = true;
				clearTimeout(navigation.secondaryMenuTimer);
				clearTimeout(navigation.mainMenuTimer);
				navigation.closeOpenSecondaryMenu();
				this.classList.add('main-menu__sub-menu-item--active');
				navigation.updateSecondaryUnderline(this);
				navigation.currentActiveSecondaryMenu = this;
			},
			false
		);
		navigation.secondaryLinks[x].addEventListener(
			'focusout',
			function (e) {
				if (window.innerWidth < navigation.config.mobileBreakPoint) return;
				// Set a timer which will automatically close our menu (if the mouse pointer has not entered the appropriate sub-menu in time)
				navigation.secondaryMenuTimer = setTimeout(function () {
					navigation.closeOpenSecondaryMenu();
					navigation.resetSecondaryUnderline();
				}, navigation.config.secondaryMouseOutDelay);
			},
			false
		);
		navigation.secondaryLinks[x].addEventListener(
			'click',
			function (e) {
				if (window.innerWidth >= navigation.config.mobileBreakPoint) {
					// Don't execute menu toggle logic when there is not a tertiary menu
					const tertiaryWrapper = e.target
						.closest('li')
						.getElementsByClassName('main-menu__tertiary-menu-wrapper');
					if (tertiaryWrapper.length < 1) return;
					// Don't excecute menu toggle logic when clicking a tertiary link
					if (
						e.target.classList.contains('main-menu__teriary-menu-item') ||
						e.target.classList.contains('main-menu__tertiary-menu-images-link')
					)
						return;
					e.preventDefault();
					clearTimeout(navigation.secondaryMenuTimer);
					clearTimeout(navigation.mainMenuTimer);
					if (this.classList.contains('main-menu__sub-menu-item--active')) {
						if (this.preventClick == true) {
							this.preventClick = false;
							return;
						}
						navigation.closeOpenSecondaryMenu();
					} else {
						navigation.closeOpenSecondaryMenu();
						this.classList.add('main-menu__sub-menu-item--active');
						navigation.updateSecondaryUnderline(this);
						navigation.currentActiveSecondaryMenu = this;
					}
				} else {
					// Don't execute menu toggle logic when there is not a tertiary menu
					const tertiaryWrapper = e.target.parentElement.getElementsByClassName(
						'main-menu__tertiary-menu-wrapper'
					);
					if (tertiaryWrapper.length < 1) return;
					// Don't excecute menu toggle logic when clicking a tertiary link
					if (e.target.classList.contains('main-menu__teriary-menu-item')) return;
					e.preventDefault();
					// On clicking the current active menu, close open menus but do not re-open the current menu
					if (
						navigation.currentActiveSecondaryMenu &&
						navigation.currentActiveSecondaryMenu.contains(e.target) &&
						navigation.currentActiveSecondaryMenu.classList.contains(
							'main-menu__sub-menu-item--active'
						)
					) {
						navigation.closeOpenSecondaryMenu();
						return;
					}
					navigation.closeOpenSecondaryMenu();
					this.classList.add('main-menu__sub-menu-item--active');
					navigation.currentActiveSecondaryMenu = this;
				}
			},
			false
		);
	}

	for (var x = 0; x < navigation.btnCloseMenu.length; x++) {
		navigation.btnCloseMenu[x].addEventListener('click', function (e) {
			e.stopPropagation();
			navigation.isFocused = false;
			clearTimeout(navigation.focusTimer);
			navigation.closeOpenPrimaryMenu();
			navigation.setDefaultActiveMenu();
			navigation.resetPrimaryUnderline();
			navigation.closeOpenSecondaryMenu();
			navigation.resetSecondaryUnderline();
			clearTimeout(navigation.secondaryMenuTimer);
			clearTimeout(navigation.mainMenuTimer);
		});
	}

	// When the mouse/keyboard leaves the tertiary nav we reset our current active sub menus
	for (var x = 0; x < navigation.tertiaryMenuWrappers.length; x++) {
		navigation.tertiaryMenuWrappers[x].addEventListener('mouseleave', function (e) {
			if (window.innerWidth < navigation.config.mobileBreakPoint) return;
			navigation.secondaryMenuTimer = setTimeout(function () {
				navigation.closeOpenSecondaryMenu();
				navigation.resetSecondaryUnderline();
			}, navigation.config.secondaryMouseOutDelay);
		});
		navigation.tertiaryMenuWrappers[x].addEventListener('blur', function (e) {
			if (window.innerWidth < navigation.config.mobileBreakPoint) return;
			navigation.secondaryMenuTimer = setTimeout(function () {
				navigation.closeOpenSecondaryMenu();
				navigation.resetSecondaryUnderline();
			}, navigation.config.mouseOutDelay);
		});
	}

	// On resize dynamically add mobile class and assign a height to our mobile nav
	window.addEventListener('resize', function () {
		if (window.innerWidth >= navigation.config.mobileBreakPoint) {
			navigation.closeOpenSecondaryMenu();
			navigation.closeOpenPrimaryMenu();
			navigation.setDefaultActiveMenu();
			navigation.currentActiveSecondaryMenu =
				navigation.defaultActiveMenu.querySelector('.main-menu__submenu');
			navigation.resetPrimaryUnderline();
			navigation.resetSecondaryUnderline();
			navigation.html.classList.remove('active');
			navigation.html.classList.remove('mobile');
			document.querySelector('body').classList.remove('navigation-active');
			navigation.mobileNavOpen = false;
		} else {
			navigation.html.classList.add('mobile');
		}
	});
	// Bind mobile nav flyout toggles
	for (var x = 0; x < navigation.mobileNavToggles.length; x++) {
		navigation.mobileNavToggles[x].addEventListener(
			'click',
			function (e) {
				navigation.toggleMobileMenu();
			},
			true
		);
	}
	// Set mobile class on load (it is by default added in the markup already), or remove class for desktop
	if (window.innerWidth < navigation.config.mobileBreakPoint) {
		navigation.html.classList.add('mobile');
	} else {
		navigation.html.classList.remove('mobile');
	}

	document.addEventListener('click', function (e) {
		if (window.innerWidth < navigation.config.mobileBreakPoint) {
			if (
				e.target !== navigation.html &&
				!navigation.html.contains(e.target) &&
				navigation.mobileNavOpen &&
				!e.target.classList.contains('icon-hamburger') &&
				!e.target.closest('.header__nav-toggle')
			) {
				navigation.toggleMobileMenu();
			}
		}
	});
};

p80.mainNavigation.prototype.updatePrimaryUnderline = function (element) {
	if (!element) return;
	const navigation = this;
	let hoverElement = element.querySelectorAll('.main-menu__item span');
	if (!hoverElement.length) return;
	hoverElement = hoverElement[0];
	const hoverElementPosition = hoverElement.getBoundingClientRect();
	const navPosition = navigation.html.getBoundingClientRect();
	const navWidth = navigation.html.offsetWidth;
	const elementWidth = hoverElement.offsetWidth;
	const elementOffset = hoverElementPosition.left - navPosition.left;
	const underlineWidth = (elementWidth / navWidth) * 100;
	const underlineOffset = (elementOffset / navWidth) * 100;
	navigation.html.style.setProperty('--primary-underline-scale-x', underlineWidth + '%');
	navigation.html.style.setProperty('--primary-underline-position-x', elementOffset + 'px');
};

p80.mainNavigation.prototype.resetPrimaryUnderline = function () {
	const navigation = this;
	let activeNavItem = navigation.html.getElementsByClassName(
		'main-menu__sub-menu-wrapper--active'
	);
	if (!activeNavItem.length) {
		navigation.html.style.setProperty('--primary-underline-scale-x', '0%');
		navigation.html.style.setProperty('--primary-underline-position-x', '0px');
		return;
	}
	activeNavItem = activeNavItem[0].querySelectorAll('.main-menu__item span');
	if (!activeNavItem.length) return;
	activeNavItem = activeNavItem[0];
	const activeElementPosition = activeNavItem.getBoundingClientRect();
	const navPosition = navigation.html.getBoundingClientRect();
	const navWidth = navigation.html.offsetWidth;
	const elementWidth = activeNavItem.offsetWidth;
	const elementOffset = activeElementPosition.left - navPosition.left;
	const underlineWidth = (elementWidth / navWidth) * 100;
	const underlineOffset = (elementOffset / navWidth) * 100;
	navigation.html.style.setProperty('--primary-underline-scale-x', underlineWidth + '%');
	navigation.html.style.setProperty('--primary-underline-position-x', elementOffset + 'px');
};

p80.mainNavigation.prototype.updateSecondaryUnderline = function (element) {
	if (!element) return;
	const navigation = this;
	if (element === navigation.currentActiveSecondaryUnderline) return;
	let hoverElement = element.querySelectorAll('.main-menu__sub-menu-item a');
	if (!hoverElement.length) return;
	hoverElement = hoverElement[0];
	const parentElement = hoverElement.closest('.main-menu__submenu');
	if (!parentElement) return;
	const hoverElementPosition = hoverElement.getBoundingClientRect();
	const navPosition = parentElement.getBoundingClientRect();
	const navWidth = parentElement.offsetWidth;
	const elementWidth = hoverElement.offsetWidth;
	const offset =
		window.innerWidth >= 1920 && window.innerWidth < 2560
			? 100
			: window.innerWidth >= 2560
				? 150
				: 50;
	const elementOffset = hoverElementPosition.left - navPosition.left - offset;
	const underlineWidth = ((elementWidth + 5) / navWidth) * 100;

	navigation.html.style.setProperty('--secondary-underline-scale-x', underlineWidth + '%');
	navigation.html.style.setProperty('--secondary-underline-position-x', elementOffset + 'px');
	navigation.currentActiveSecondaryUnderline = element;
};

p80.mainNavigation.prototype.resetSecondaryUnderline = function () {
	const navigation = this;
	let activeNavItem = navigation.html.getElementsByClassName(
		'main-menu__sub-menu-wrapper--active'
	);
	navigation.currentActiveSecondaryUnderline = null;
	if (!activeNavItem.length) {
		navigation.html.style.setProperty('--secondary-underline-scale-x', '0%');
		navigation.html.style.setProperty('--secondary-underline-position-x', '0px');
		return;
	}
	const activeSubNav = activeNavItem[0].getElementsByClassName(
		'main-menu__sub-menu-item--active-children'
	);
	if (!activeSubNav.length) {
		navigation.html.style.setProperty('--secondary-underline-scale-x', '0%');
		navigation.html.style.setProperty('--secondary-underline-position-x', '0px');
		return;
	}
	activeNavItem = activeSubNav[0].querySelectorAll('a');
	if (!activeNavItem.length) {
		navigation.html.style.setProperty('--secondary-underline-scale-x', '0%');
		navigation.html.style.setProperty('--secondary-underline-position-x', '0px');
		return;
	}
	activeNavItem = activeNavItem[0];
	const parentElement = activeNavItem.closest('.main-menu__submenu');
	if (!parentElement) return;
	const hoverElementPosition = activeNavItem.getBoundingClientRect();
	const navPosition = parentElement.getBoundingClientRect();
	const navWidth = parentElement.offsetWidth;
	const elementWidth = activeNavItem.offsetWidth;
	const offset =
		window.innerWidth >= 1920 && window.innerWidth < 2560
			? 100
			: window.innerWidth >= 2560
				? 150
				: 50;
	const elementOffset = hoverElementPosition.left - navPosition.left - offset;
	const underlineWidth = ((elementWidth + 5) / navWidth) * 100;

	navigation.html.style.setProperty('--secondary-underline-scale-x', underlineWidth + '%');
	navigation.html.style.setProperty('--secondary-underline-position-x', elementOffset + 'px');
	navigation.currentActiveSecondaryUnderline = activeNavItem.closest('li');
};

// Closes the current open menu
p80.mainNavigation.prototype.closeOpenPrimaryMenu = function (button) {
	const navigation = this;
	if (navigation.currentActiveMenu) {
		navigation.currentActiveMenu.classList.remove('main-menu__sub-menu-wrapper--active');
	}
};

// Closes the current open secondary menu
p80.mainNavigation.prototype.closeOpenSecondaryMenu = function (button) {
	const navigation = this;
	if (navigation.currentActiveSecondaryMenu) {
		navigation.currentActiveSecondaryMenu.classList.remove('main-menu__sub-menu-item--active');
	}
};

// Adds an active class back to our default menu view when all others have been closed.
p80.mainNavigation.prototype.setDefaultActiveMenu = function () {
	const navigation = this;
	if (navigation.defaultActiveMenu) {
		navigation.currentActiveMenu = navigation.defaultActiveMenu;
		navigation.defaultActiveMenu.classList.add('main-menu__sub-menu-wrapper--active');
		navigation.resetSecondaryUnderline();
	}
};

p80.mainNavigation.prototype.toggleMobileMenu = function () {
	const navigation = this;
	if (navigation.mobileNavOpen) {
		navigation.html.classList.remove('active');
		document.querySelector('body').classList.remove('navigation-active');
	} else {
		navigation.html.classList.add('active');
		document.querySelector('body').classList.add('navigation-active');
	}
	navigation.mobileNavOpen = !navigation.mobileNavOpen;
};

window.addEventListener('DOMContentLoaded', (event) => {
	const accountToggle = document.querySelector('.account-top-menu__toggle-sidebar');
	if (accountToggle) {
		accountToggle.addEventListener('click', function (e) {
			const target = document.getElementById('#MainContent');
			if (!target) return;
			target.classList.toggle('mobile-show-sidebar');
		});
	}
	const activeSidebarLink = document.querySelector('.sidebar__menu-link--active');
	if (
		activeSidebarLink &&
		window.location.pathname.includes(activeSidebarLink.getAttribute('href'))
	) {
		activeSidebarLink.addEventListener('click', function (e) {
			e.preventDefault();
			const target = document.getElementById('#MainContent');
			if (!target) return;
			target.classList.toggle('mobile-show-sidebar');
		});
	}
});

if (document.getElementById('main-menu')) {
	new p80.mainNavigation();
}
